<template>
  <!--<div class="home">-->
    <!--<img src="../assets/logo.png">-->
    <!--<HelloWorld msg="Welcome to Your Vue.js App"/>-->
  <!--</div>-->
    <div class="wrap">
        <h1>약국 정보</h1>
        <div class="doctor-view-wrap">
            <div class="dr-profile">
                <h2>기본 정보
                    <!-- <p class="profile-notice">* 프로필 수정을 꼭 하셔야 합니다. (프로필 이미지 및 병원정보 등)</p> -->
                </h2>
                <!-- img -->
                <div class="dr-profile-box clearfix"> 
                    <div class="profile-img">
                        <p class="profile-img-wrap" :title="img_title_view(this.pharm.pharm_img_sm)">
                            <img :src="pharm.pharm_img_sm">
                        </p>
                    </div>
                    <div class="profile-name">
                        <!-- <p class="cate">{{ pharm.specialty_name }}</p> -->
                        <h4 class="name">{{ pharm.pharm_name }}</h4>
                        <!-- <div class="recommend clearfix">
                            <p>{{ pharm.rec_stars }}</p><span class="recommend-q" title="상담회원들로부터 받은 모든 별 갯수">?</span>
                        </div> -->
                    </div>
                    <!-- <div>
                      <input type="checkbox" name="is-overseas" id="is-overseas" v-model="pharm.is_overseas_on" @click="set_overseas($event.target.checked)">
                      <label for="is-overseas"> 영어 상담 가능 </label>
                    </div> -->
                </div>
                <!-- txt -->
                <!-- <div class="dr-profile-box clearfix">
                    <div class="profile-txt profile-txt-lt">닉네임</div>
                    <div class="profile-txt profile-txt-rt">{{ pharm.nickname }}</div>
                </div>
                <div class="dr-profile-box clearfix">
                    <div class="profile-txt profile-txt-lt">인사말</div>
                    <div class="profile-txt profile-txt-rt">{{ pharm.pharm_intro }}</div>
                </div>
                <div class="dr-profile-box clearfix">
                    <div class="profile-txt profile-txt-lt">소개 이미지</div>
                    <div class="profile-txt profile-txt-rt">
                        <ImagesGalleryDr v-model="pharm.pharm_imgs" :editable="false"></ImagesGalleryDr>
                    </div>
                </div>
                <div class="dr-profile-box clearfix">
                    <div class="profile-txt profile-txt-lt">소개 영상</div>
                    <div class="profile-txt profile-txt-rt">
                        <ul>
                            <li v-for="(record, idx) in pharm.pharm_intro_url">{{ record }}</li>
                        </ul>
                    </div>
                </div>
                <div class="dr-profile-box clearfix">
                    <div class="profile-txt profile-txt-lt">대표 진료 과목</div>
                    <div class="profile-txt profile-txt-rt">{{ pharm.specialty_name }}</div>
                </div>
                <div class="dr-profile-box clearfix">
                    <div class="profile-txt profile-txt-lt">전문 상담 분야</div>
                    <div class="profile-txt profile-txt-rt">{{ consults_text }}</div>
                </div>
                <div class="dr-profile-box clearfix">
                    <div class="profile-txt profile-txt-lt">약력</div>
                    <div class="profile-txt profile-txt-rt">
                        <ul>
                            <li v-for="(record, idx) in pharm.history">{{ record }}</li>
                        </ul>
                    </div>
                </div> -->
            </div>
            <div class="add-profile">
                <!-- txt -->
                <div class="add-profile-box clearfix">
                    <div class="profile-txt profile-txt-lt">약국정보</div>
                    <div class="profile-txt profile-txt-rt">
                        <div class="txt-rt">
                            <ul>
                                <li>
                                    <div class="tt">약국명</div>
                                    <div class="msg">{{ pharmacy.pharm_name }}</div>
                                </li>
                                <li>
                                    <div class="tt">주소</div>
                                    <div class="msg">{{ pharmacy.location }} {{ pharmacy.adpharm_detail }}</div>
                                </li>
                                <li>
                                    <div class="tt">전화번호</div>
                                    <div class="msg">{{ pharmacy.pharm_tel }}</div>
                                </li>
                                <li>
                                    <div class="tt">팩스번호</div>
                                    <div class="msg">{{ pharmacy.pharm_fax }}</div>
                                </li>
                                <li>
                                    <div class="tt">대표약사</div>
                                    <div class="msg">{{ pharm.pharmacy_pharm_name }}</div>
                                </li>
                                <li>
                                    <div class="tt">이메일</div>
                                    <div class="msg">{{ pharm.email }}</div>
                                </li> 
                                <li>
                                    <div class="tt">휴대폰</div>
                                    <div class="msg">{{ pharm.contact | phone_format }}</div>
                                </li>                               
                                <li>
                                    <div class="tt">담당자</div>
                                    <div class="msg">{{ this.pharmacist_text }} {{ this.pharmacist_tel_text }}</div>
                                </li>
                                <!-- <li>
                                    <div class="tt">약사면허증</div>
                                    <div class="msg">
                                        <p class="profile-copy-img-wrap">
                                            <img :src="pharm.pharm_img_sm">
                                        </p>
                                    </div>
                                </li>
                                <li>
                                    <div class="tt">약국개설등록증</div>
                                    <div class="msg">
                                        <p class="profile-copy-img-wrap">
                                            <img :src="pharm.pharm_img_sm">
                                        </p>
                                    </div>
                                </li> -->
                                <li>
                                    <div class="tt">사업자등록증</div>
                                    <div class="msg">
                                        <p class="profile-copy-img-wrap">
                                            <img :src="pharm.pharm_img_sm">
                                        </p>
                                    </div>
                                </li>
                                <!-- <li>
                                    <div class="tt">통장사본</div>
                                    <div class="msg">
                                        <p class="profile-copy-img-wrap">
                                            <img :src="pharm.pharm_img_sm">
                                        </p>
                                    </div>
                                </li> -->
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="profile-btn">
            <button type="button" @click="$router.push(`/profile/edit`)">수정</button>
        </div>
    </div>

</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import oh from '@/lib/object_helper'
import { mapState } from 'vuex'
import ImagesGallery from '@/components/ProfileEdit/ImagesGallery.vue'
import ImagesGalleryDr from '@/components/ProfileEdit/ImagesGalleryDr.vue'
import { nameByConstMixin } from '@/lib/mixins'

export default {
  mixins: [nameByConstMixin],
  name: 'profile-view',
  data () {
    return {
      pharmacy: {
        pharm_id: '',
        pharm_name: '',
        pharm_intro: '',
        homepage: '',
        pharm_tel: '',
        pharm_fax: '',
        location: '',
        adpharm_detail: '',
        pharm_imgs: [], // 서버에서 내려주는 가공된 이미지 데이터(W/ URL)
        del_imgs: [], // 이거 뭐하는 녀석인지 알아낸다!
        uploaded_files: [], // 업로드가 있을때만 보낸다.
        manager: []
      },
      pharm: {
        pharm_id: null,
        pharm_name: null,
        email: null,
        contact: null,
        pharm_img: null,
        pharm_img_sm: null,
        pharm_intro: null,
        pharm_intro_url: null,
        rec_drs: null, // 이거 null나옴
        pharmacy_id: null,
        rec_stars: 0, // 이거 필요한가?
        pharmacy_pharm_name: null,
        pharm_imgs: [], // 서버에서 내려주는 가공된 이미지 데이터(W/ URL)
        pharmacist: [],
        pharmacist_tel: [],
      },
      msg: '프로필 이미지를 등록해 주세요.'
    }
  },
  computed: {
    ...mapState(['account']),
    manager_text () {
      return this.pharmacy.manager.join(', ')
    },
    pharmacist_text () {
      return this.pharm.pharmacist.join(', ')
    },
    pharmacist_tel_text () {
      return this.pharm.pharmacist_tel.join(', ')
    },
  },
  methods: {

    async getPharmData (pharm_id) {

      let chosen_fields = Object.keys(this.pharm)
      let {data: {resp}} = await this.axios.get(`pharmacist/${pharm_id}`)

      for (let key of chosen_fields) {
        if (key in resp) {
          this.pharm[key] = resp[key]
        }
      }

    //   console.log('getDrData')
      // this.dr = resp
    },
    async getPharmacyData (pharm_id) {

      let chosen_fields = Object.keys(this.pharmacy)
      let {data: {resp}} = await this.axios.get(`pharmacy/${pharm_id}`)

      for (let key of chosen_fields) {
        if (key in resp) {
            this.pharmacy[key] = resp[key]
        }
      }
    }
  },
  async mounted () {
    await this.getPharmData(this.account.pharm_id)
    await this.getPharmacyData(this.pharm.pharmacy_id)
  },
  components: {
    ImagesGallery, ImagesGalleryDr
  }
}
</script>

<style scoped>
    /* Contents
    ------------------------------------------------------- */
    .wrap {
        width: 100%;
        max-width: 1280px;
        margin: 55px auto;
    }

    .wrap > h1 {
        color: #494949;
        margin-bottom: 30px;
        letter-spacing: -.5px;
        font: 400 24px 'Noto Sans KR', sans-serif;
    }

    .wrap > div {
        width: 100%;
        background-color: #fff;
        border: 1px solid #eee;
        box-sizing: border-box;
    }

    .doctor-view-wrap,
    .hospital-view-wrap {
        padding: 30px;
    }
    
    .doctor-view-wrap {
        margin-bottom: 10px;
    }

    .wrap .profile-btn {
        width: 160px;
        height: 50px;
        margin: 20px auto;
    }

    .wrap .profile-btn button {
        color: #8d8d8d;
        width: 100%;
        height: 100%;
        border: none;
        padding: 0;
        outline: 0;
        cursor: pointer;
        background-color: transparent;
        font: 400 18px/48px 'Noto Sans KR', sans-serif;
    }

     .dr-profile > h2 {
        color: #474747;
        margin-bottom: 40px;
        letter-spacing: -.5px;
        font: 400 18px 'Noto Sans KR', sans-serif;
    }

    .dr-profile-box:first-of-type {margin-bottom: 20px;}
    .dr-profile-box:nth-of-type(n+2) {margin-bottom: 10px;}

    .dr-profile-box > div {
        float: left;
    }

    .profile-img,
    .profile-txt-lt {
        width: 170px;
    }

    .profile-img > p {
        display: block;
        height: 120px;
        width: 120px;
        margin: 0 auto 10px;
        border-radius: 50%;
        background-image: url('../assets/home/profile-default.jpg');
    }

    .profile-img img {
        width: 100%
    }

    .profile-img-wrap {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        background-color: #ccc;
        font-size: 10px;
        overflow: hidden;
    }

    .profile-copy-img-wrap {
        width: 80px;
        height: 80px;
        background-color: #ccc;
        font-size: 10px;
        overflow: hidden;
    }

    .profile-name .cate {
        display: inline-block;
        color: #6e6fe5;
        padding: 2px 20px;
        box-sizing: border-box;
        border: 1px solid #6e6fe5;
        font: 400 16px 'Noto Sans KR', sans-serif;
    }

    .profile-name .name {
        margin: 7px 0 5px;
        font: 500 32px 'Noto Sans KR', sans-serif;
    }

    .profile-name .recommend > p,
    .profile-name .recommend > span {
        float: left;
        color: #676767;
    }

    .profile-name .recommend > p {
        text-indent: 25px;
        font: 500 14px 'Noto Sans KR', sans-serif;
        background: url(../assets/home/star.png) 0 center/18px no-repeat;
    }

    .profile-name .recommend > span {
        display: inline-block;
        width: 16px;
        height: 16px;
        margin: 5px 0 0 7px;
        text-align: center;
        border: 1px solid #999;
        border-radius: 50%;
        box-sizing: border-box;
        font: 600 8px/14px 'Noto Sans KR', sans-serif;
    }

    .profile-txt {
        font: 400 14px 'Noto Sans KR', sans-serif;
    }

    .add-profile > h2 {
        color: #474747;
        margin-bottom: 40px;
        letter-spacing: -.5px;
        font: 400 18px 'Noto Sans KR', sans-serif;
    }

    .add-profile-box {margin-bottom: 20px;}
    .add-profile-box:last-of-type {margin-bottom: none;}

    .add-profile-box > div {
        float:left;
    }

    .profile-txt {font: 400 14px 'Noto Sans KR', sans-serif;}

    .profile-txt-lt {
        width: 170px;
        color: #454545;
        text-indent: 20px;
    }
    .add-profile-box .profile-txt-rt{
        float:none;
        overflow:hidden;
        display:block;
    }

    .profile-txt-rt {
        color: #b1b1b1;
    }

    .profile-txt-rt > div {
        float:left;
    }
    .profile-txt-rt > div li {
        min-height:24px;
        margin-bottom: 10px;
    }
    .profile-txt-rt .tt{float:left; min-width:110px; color:#b1b1b1;}
    .profile-txt-rt .msg{overflow:hidden;}
    .profile-txt-rt .txt-lt {
        width: 100px;
    }
    .profile-txt-rt .txt-rt {
        float:none;
        display:block;
        overflow:hidden;
        color: #000;
    }

    .profile-txt-rt .txt-rt li p {
        color: #b1b1b1;
        margin-top: 10px;
    }

    .add-profile-thumb {font-size: 0;}
    .add-profile-thumb > img {
        float: left;
        margin: 0 10px 10px 0;
    }

    .profile-notice {
        color: #adadad;
        margin: 2px 0 14px;
        letter-spacing: -.5px;
        font: 400 14px 'Noto Sans KR', sans-serif;
    }

    .tooltip {
        color: rgba(#004499, .9);
    }

    .tooltip .info {
        color: rgba(#004499, .9);
    }

    .tooltip .info .tooltip-inner {
        background: black;
        color: white;
        padding: 24px;
        border-radius: 5px;
        box-shadow: 0 5px 30px rgba(black, .1);
        max-width: 250px;
    }

    .tooltip .info .tooltip-arrow {
        border-color: black;
    }

</style>
